import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { InParkingCardDetail } from 'src/features/cards/types/card';

const RESOURCE = '/parkings/:parkingId/cards/in-parking/:cardId/pay/';

type PayInParkingCardFnType = typeof payInParkingCard;

export type PayInParkingCardDTO = {
    parkingId: string;
    cardId: number;
    paid_amount: number;
    paid_tax_amount: number;
    paid_amount_with_tax: number;
    vat: number;
    pricing_plan_id: number;
    status: string;
    payment_method: string;
    fiscal_unp?: string;
    fiscal_doc_number?: string;
};

export const payInParkingCard = ({ parkingId, cardId, ...data }: PayInParkingCardDTO): Promise<InParkingCardDetail> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, cardId }), data);
};

interface UsePayInParkingCardOptions extends MutationConfig<PayInParkingCardFnType, GeneralSmartParkError> {}

export const usePayInParkingCard = (options: UsePayInParkingCardOptions = {}) =>
    useMutation({
        mutationFn: payInParkingCard,
        ...options,
    });
